import { render, staticRenderFns } from "./OraArrivo.vue?vue&type=template&id=3462b586&"
import script from "./OraArrivo.vue?vue&type=script&lang=js&"
export * from "./OraArrivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports